import { connect } from "react-redux";

import GlobalSection from "../../components/sections/global_section";
import { routes, currentTabIs } from "../../routes";

const mapStateToProps = (state) => {
  const isLoading = state.main.loading.tabIsLoading;
  const countrySelected = !!state.main.filters.country.selectedValue;
  const onMapTab = currentTabIs(state, routes.global.tabs.change_map.slug);
  const hasMainChart = !!state.main.loading.loadedData.mainChart;

  return { isLoading, countrySelected, onMapTab, hasMainChart };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSection);
